var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMistake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1631003614586,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 15565,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M438.76 904.49H164.8c-47.23 0-85.65-38.42-85.65-85.66V164.8c0-47.23 38.42-85.65 85.65-85.65h582.43c47.23 0 85.66 38.42 85.66 85.65v250.15c0 21.85 17.72 39.57 39.57 39.57s39.57-17.72 39.57-39.57V164.8C912.03 73.93 838.1 0 747.23 0H164.8C73.93 0 0 73.93 0 164.8v654.04c0 90.87 73.93 164.8 164.8 164.8h273.96c21.85 0 39.57-17.72 39.57-39.57s-17.72-39.58-39.57-39.58z",
    "p-id": 15566,
    fill: "#d81e06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M761.26 494.76c-144.87 0-262.74 117.86-262.74 262.74s117.86 262.74 262.74 262.74S1024 902.37 1024 757.5 906.14 494.76 761.26 494.76z m0 450.1c-103.31 0-187.36-84.05-187.36-187.36 0-103.31 84.05-187.36 187.36-187.36s187.36 84.05 187.36 187.36c0.01 103.31-84.04 187.36-187.36 187.36zM605.67 186.55H194.09c-21.85 0-39.57 17.72-39.57 39.57s17.72 39.57 39.57 39.57h411.59c21.85 0 39.57-17.72 39.57-39.57s-17.72-39.57-39.58-39.57zM605.67 344.84H194.09c-21.85 0-39.57 17.72-39.57 39.57s17.72 39.57 39.57 39.57h411.59c21.85 0 39.57-17.72 39.57-39.57s-17.72-39.57-39.58-39.57zM452.24 503.12H194.09c-21.85 0-39.57 17.72-39.57 39.57s17.72 39.57 39.57 39.57h258.16c21.85 0 39.57-17.72 39.57-39.57s-17.72-39.57-39.58-39.57z",
    "p-id": 15567,
    fill: "#d81e06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M856.19 665.95c-14.72-14.72-38.58-14.72-53.3 0l-40.56 40.56-40.56-40.56c-14.72-14.72-38.58-14.72-53.3 0-14.72 14.72-14.72 38.58 0 53.3l40.56 40.56-40.56 40.56c-14.72 14.72-14.72 38.58 0 53.3 7.36 7.36 17.01 11.04 26.65 11.04s19.29-3.68 26.65-11.04l40.56-40.56 40.56 40.56c7.36 7.36 17.01 11.04 26.65 11.04s19.29-3.68 26.65-11.04c14.72-14.72 14.72-38.58 0-53.3l-40.56-40.56 40.56-40.56c14.72-14.72 14.72-38.58 0-53.3z",
    "p-id": 15568,
    fill: "#d81e06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMistake);
export default __webpack_public_path__ + "static/media/mistake-.52e970b2ea3f09883a5fd3eb4df403fa.svg";
export { ForwardRef as ReactComponent };